import React, { useRef, useState } from 'react';

import {
  Button,
  Col,
  Modal,
  Nav,
  Row,
  Tab,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useClickAway } from 'react-use';
import profileImg from '../../../assets/images/profile.svg';
import WebcamCapture from '../../../components/doctors/modals/WebcamCapture';
import BasicPatientForAppointment from '../../../components/doctors/partials/basicPatientForAppointment';
import MedicalPatientForAppointment from '../../../components/doctors/partials/medicalPatientForAppointment';
import OthersPatientInfo from '../../../components/doctors/partials/othersPatientInfo';
import LoadingButton from '../../../components/forms/LoadingButton';
import { useValidation } from '../../../hooks/validationHooks/useValiation';
import { deleteRequest } from '../../../utils/axiosRequests';
import {
  agePrint,
  capitalizeFirstLetter,
  separateDateTime,
} from '../../../utils/helpers';

function AddPatientInfo({
  patientPicture,
  patientInfo,
  setPatientInfo,
  infoModal,
  setInfoModal,
  selectedOnExamination,
  setSelectedOnExamination,
  appointmentInfo,
  setAppointmentInfo,
  fromPage = '',
  handleSubmit = '',
}) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [patientId, setPatientId] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [errors, setErrors] = useState({});
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [visitType, setVisitType] = useState('new');
  const [visitationFee, setVisitationFee] = useState('');
  const [patientType, setPatientType] = useState('new');
  const validation = useValidation;

  const ref = useRef(null);
  useClickAway(ref, () => {
    setInfoModal(false);
  });

  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  const ageProperties = patientSettings?.items?.find(
    (item) => item.name === 'age',
  );
  let { unitProperties } = ageProperties || {};
  let navigate = useNavigate();

  const deletePatientImage = () => {
    if (patientPicture) {
      const confirmDelete = window.confirm(
        'Are you sure you want to delete this image?',
      );
      // Proceed with deletion if confirmed
      if (confirmDelete) {
        deleteRequest(`auth/patient-img-delete/${patientInfo.id}`)
          .then((res) => {
            console.log(res, 'deletePatientImage');
          })
          .catch((error) => {});
      }
    } else {
      setImageSrc(null);
    }
  };

  const selectSearchResult = (selectedUser) => {
    setPatientInfo({ ...selectedUser[0] });
    setPatientId(selectedUser[0]?.id);
  };

  return (
    <Modal show={infoModal} dialogClassName="custom-modal-width">
      <Modal.Header className="common-modal-header">
        <Col lg={10} md={10} sm={10} xs={10}>
          <Modal.Title>Patient Info</Modal.Title>
        </Col>
        <Col lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'end' }}>
          <i
            onClick={() => {
              setInfoModal(false);
            }}
            className="fa fa-times-circle cursor-pointer"
            aria-hidden="true"
          ></i>
        </Col>
      </Modal.Header>
      <Modal.Body ref={ref}>
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card shadow">
              <div className="card-body patient-history patient-info">
                <Row>
                  <Col
                    md={3}
                    className="patient-details pt-3"
                    style={{ fontSize: '15px' }}
                  >
                    <div className="icon-list">
                      <i
                        className="fa fa-plus-circle"
                        onClick={() => setIsOpenCamera(true)}
                      ></i>
                      <i
                        className="fa fa-edit"
                        onClick={() => setIsOpenCamera(true)}
                      ></i>
                      {(patientPicture || imageSrc) && (
                        <i
                          className="fa fa-times-circle cursor-pointer"
                          onClick={() => deletePatientImage()}
                        ></i>
                      )}
                    </div>
                    <div className="patient-img-info">
                      {!isOpenCamera ? (
                        <img
                          className="profile-img"
                          src={imageSrc || patientPicture || profileImg}
                        />
                      ) : (
                        <>
                          <WebcamCapture
                            imageSrc={imageSrc}
                            setImageSrc={setImageSrc}
                            isOpenCamera={isOpenCamera}
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            setIsOpenCamera={setIsOpenCamera}
                          />
                        </>
                      )}
                      <div className="font-weight-bold mt-2">
                        {patientInfo?.name}
                      </div>
                      <div>{patientInfo?.phoneNumber}</div>
                      <div className="light-blue-color">
                        {patientInfo?.email}
                      </div>
                    </div>
                    <hr />
                    <Row className="text-center">
                      <Col>
                        <Row>
                          <Col>
                            <div className="label-bold">Gender</div>
                            <div className="mt-2 greyColor">
                              {capitalizeFirstLetter(patientInfo?.gender)}
                            </div>
                            <hr />
                          </Col>
                          <Col>
                            <div className="label-bold">Age</div>
                            <div className="mt-2 greyColor">
                              {agePrint(
                                separateDateTime(patientInfo?.dob),
                                unitProperties,
                              )}
                            </div>
                            <hr />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="label-bold">Height</div>
                            <div className="mt-2 greyColor">
                              {
                                selectedOnExamination?.generalExaminations
                                  ?.heightInfo?.feet
                              }
                              {selectedOnExamination?.generalExaminations
                                ?.heightInfo?.inch
                                ? '.' +
                                  selectedOnExamination.generalExaminations
                                    ?.heightInfo?.inch
                                : ''}
                              {selectedOnExamination?.generalExaminations
                                ?.heightInfo?.feet ||
                              selectedOnExamination.generalExaminations
                                ?.heightInfo?.inch
                                ? ' ' +
                                  selectedOnExamination.generalExaminations
                                    ?.heightInfo?.heightUnit
                                : ''}
                            </div>
                            <hr />
                          </Col>
                          <Col>
                            <div className="label-bold">Weight</div>
                            <div className="mt-2 greyColor">
                              {selectedOnExamination?.generalExaminations
                                ?.weightInfo?.weight
                                ? selectedOnExamination.generalExaminations
                                    ?.weightInfo?.weight +
                                  ' ' +
                                  selectedOnExamination.generalExaminations
                                    ?.weightInfo?.weightUnit
                                : ''}
                            </div>
                            <hr />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={9} className="pl-4">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="basic"
                    >
                      <Nav
                        variant="pills"
                        className="d-flex custom-tab"
                        style={{
                          alignItems: 'center',
                          textAlign: 'center',
                        }}
                      >
                        <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="basic">
                            Basic Information
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="medical">
                            Medical Information
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="flex-fill">
                          <Nav.Link eventKey="others">Others</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane eventKey="basic">
                          <BasicPatientForAppointment
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            selectSearchResult={selectSearchResult}
                            setPhoneNumber={setPhoneNumber}
                            phoneNumber={phoneNumber}
                            appointmentInfo={appointmentInfo}
                            patientType={patientType}
                            setPatientType={setPatientType}
                            errors={errors}
                            setAppointmentDateTime={setAppointmentDateTime}
                            visitType={visitType}
                            setVisitType={setVisitType}
                            setVisitationFee={setVisitationFee}
                            isEdit={false}
                            selectedOnExamination={selectedOnExamination}
                            setSelectedOnExamination={setSelectedOnExamination}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="medical">
                          <MedicalPatientForAppointment
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            selectedOnExamination={selectedOnExamination}
                            appointmentInfo={appointmentInfo}
                            setAppointmentDateTime={setAppointmentDateTime}
                            setSelectedOnExamination={setSelectedOnExamination}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="others">
                          <OthersPatientInfo
                            patientInfo={patientInfo}
                            setPatientInfo={setPatientInfo}
                            appointmentInfo={appointmentInfo}
                            setAppointmentInfo={setAppointmentInfo}
                          />
                        </Tab.Pane>
                        {fromPage && fromPage === 'patientHistory' && (
                          <Row className="mt-2 mb-2">
                            <Col className="text-center">
                              {isLoading ? (
                                <LoadingButton btnFull="yes" />
                              ) : (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  style={{ width: 'inherit' }}
                                  onClick={() => handleSubmit()}
                                >
                                  <b>Done</b>
                                </Button>
                              )}
                            </Col>
                          </Row>
                        )}
                      </Tab.Content>
                    </Tab.Container>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddPatientInfo;
